module.exports = "../fonts/SFUIText-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Light.woff
// module id = 578
// module chunks = 0